var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.infoItems),function(item){return _c('div',{key:item.title,staticClass:"w-50"},[_c('div',{staticClass:"font-weight-bold "},[_vm._v(_vm._s(item.title))]),_vm._v(" "+_vm._s(item.data)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }